import GenericBody from "../Componentes/GenericBody";
import NavBar from "../Componentes/NavBar";
import Content from "../Modulos/Contabilidade/Home/Content";

const Contabilidade = () => {
    return (
        <>
            <NavBar
                title="CONTABILIDADE"
                navTo="/modules"
            />
            <GenericBody>
                <Content />
            </GenericBody>
        </>
    );
};

export default Contabilidade;
